import { BaseAnalyticsFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { TopExperienceDataDto } from '@repo/shared/dtos/analytics/AnalyticsResponseDto';
import { useTopExperiences } from '../../../hooks/analytics/useAnalytics';
import { BaseRankingCard, ItemModalProps } from '../shared';
import { TopExperiencesModal } from './TopExperiencesModal';
import { ExperienceBreakdownModal } from './ExperienceBreakdownModal';

interface TopExperiencesCardProps {
  filters: BaseAnalyticsFilter;
}

function ExperienceDetailModalWrapper({
  isOpen,
  onClose,
  item,
  filters,
}: ItemModalProps<TopExperienceDataDto, BaseAnalyticsFilter>) {
  if (!item) return null;

  return (
    <ExperienceBreakdownModal
      experienceTitle={item.experienceTitle}
      filters={filters}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}

export function TopExperiencesCard({ filters }: TopExperiencesCardProps) {
  return (
    <BaseRankingCard
      title="Top Sessions"
      filters={filters}
      dataHook={useTopExperiences}
      getTitle={(exp: TopExperienceDataDto) => exp.experienceTitle}
      getMainMetric={(exp: TopExperienceDataDto) => exp.sessionCount}
      getSecondaryMetric={(exp: TopExperienceDataDto) => exp.totalMinutes}
      getPercentage={(exp: TopExperienceDataDto) => exp.percentage}
      titleMaxLength={15}
      emptyMessage="No session data available"
      DetailModal={TopExperiencesModal}
      ItemModal={ExperienceDetailModalWrapper}
    />
  );
}
